._8s9kc80 {
  position: fixed;
  bottom: 1rem;
  width: max-content;
  max-width: 90%;
  left: 50%;
  font-size: 14px;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 1.5rem;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(3px);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08), 0px 8px 12px rgba(0, 0, 0, 0.16);
  transition: opacity 0.15s ease;
  pointer-events: none;
  z-index: 2147480002;
}
._8s9kc81 {
  color: white;
}